/* unplugin-vue-components disabled */import script from "./ProductDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailModal.vue?vue&type=style&index=0&id=e35b1dbe&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e35b1dbe"]])

export default __exports__